<template>
    <div>
        <ams-base-chart :chartTitle="`Count of ${label('Debriefs')} with Learning Identified by Callsign`" :chartType="ChartTypes.BAR" :data="chartData" :stacked="true" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ChartTypes } from '../../../../../../enums';
import { Colors } from '../../../../../../utilities/colors';
import { toCapitalize } from '../../../../../../utilities';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();

const props = defineProps({
    jsonData: {
        type: Array,
    },
});

const chartData = ref([]);

onMounted(() => {
    loadChartData();
});

const loadChartData = () => {
    const learnings = ['Yes', 'No'];
    chartData.value = props.jsonData?.map((data) => {
        return {
            label: toCapitalize(data.name),
            values: learnings.map((learning) => {
                const item = data.learning?.find((item) => item.name === learning);
                return {
                    label: learning,
                    value: item ? item.tot : 0,
                    bgcolor: learning === 'Yes' ? Colors.BLUE : Colors.RED,
                };
            }),
        };
    });
};
</script>
